import { initializeApp } from 'firebase/app';
import {
  getAuth, connectAuthEmulator, onAuthStateChanged,
  signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword
} from 'firebase/auth';
import {
  getFunctions, connectFunctionsEmulator
} from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
import { AuthUserInfo } from './lib/user';

const isDev = window.location.hostname === 'localhost';

const firebaseConfig = {
  apiKey: "AIzaSyCiBNtco-B7Q30kejfFcrPZ6ckay65m798",
  authDomain: "bathory-dse.firebaseapp.com",
  projectId: "bathory-dse",
  storageBucket: "bathory-dse.appspot.com",
  messagingSenderId: "260069712678",
  appId: "1:260069712678:web:7e883e75562d8f0d4517e7",
  measurementId: "G-NS9VH3FF1C"
};

const app = initializeApp(firebaseConfig);
export default app;
export const analytics = getAnalytics(app);

export function initializeFirebase() {
  if (isDev) {
    console.log('%cDeveloper enviroment', 'color: white; font-size: 32px; font-weight: 700;');
    console.log('%cUsing Firebase Emulator Suite...', 'color: orange; font-size: 20px;');

    connectAuthEmulator(getAuth(app), 'http://localhost:9099');
    connectFirestoreEmulator(getFirestore(app), 'localhost', 8080);
    connectFunctionsEmulator(getFunctions(app), 'localhost', 5001);
    connectStorageEmulator(getStorage(app), 'localhost', 9199);
  }

  onAuthStateChanged(getAuth(app), async (user) => {
    if (!!user) {
      console.log('User info:', {
        admin: ((await user.getIdTokenResult()).claims as any)[ 'admin' ],
        displayName: user.displayName!,
        email: user.email!,
        uid: user.uid
      } as AuthUserInfo);
    }
    else console.warn('User info:', null);
  })

    //Debug, but can be left in there for production
    ; (window as any).logout = () => logout();
  ; (window as any).login = (email: string, pass: string) => login(email, pass);
}

function getAuthUser() {
  const user = getAuth(app).currentUser;
  if (!user) throw new Error('No auth user found.');
  else return user;
}

export function getUID() {
  return getAuthUser().uid;
}

export async function login(email: string, pass: string) {
  await signInWithEmailAndPassword(getAuth(app), email, pass);
}

export async function logout() {
  await signOut(getAuth(app));
}

export async function register(email: string, pass: string) {
  await createUserWithEmailAndPassword(getAuth(app), email, pass);
}
